import React from "react";
import { useDevice } from "@crystal/core";
import logo from "./adi-club-logo.svg.js";
import loader from "./loader.gif.js";
const Loader = ({ showLogo = false }) => {
  const { isMobile } = useDevice();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: isMobile ? "70vh" : "500px"
      }
    },
    showLogo && /* @__PURE__ */ React.createElement("img", { height: "25px", src: logo }),
    /* @__PURE__ */ React.createElement("img", { height: "48px", src: loader, style: { marginTop: showLogo ? "40px" : "0px" } })
  );
};
export {
  Loader
};
//# sourceMappingURL=Loader.js.map
